var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 15H14.5C14.9142 15 15.25 15.3358 15.25 15.75C15.25 16.1297 14.9678 16.4435 14.6018 16.4932L14.5 16.5H5.5C5.08579 16.5 4.75 16.1642 4.75 15.75C4.75 15.3703 5.03215 15.0565 5.39823 15.0068L5.5 15H14.5H5.5ZM9.89823 3.00685L10 3C10.3797 3 10.6935 3.28215 10.7432 3.64823L10.75 3.75V11.438L13.0052 9.18414C13.2715 8.91787 13.6881 8.89366 13.9817 9.11152L14.0659 9.18414C14.3321 9.4504 14.3563 9.86707 14.1385 10.1607L14.0659 10.2448L10.5303 13.7803C10.2641 14.0466 9.8474 14.0708 9.55379 13.8529L9.46967 13.7803L5.93414 10.2448C5.64124 9.9519 5.64124 9.47703 5.93414 9.18414C6.2004 8.91787 6.61707 8.89366 6.91068 9.11152L6.9948 9.18414L9.25 11.44V3.75C9.25 3.3703 9.53215 3.05651 9.89823 3.00685L10 3L9.89823 3.00685Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.f230d381ed71bb41e9c02346a1172675.svg";
export { ForwardRef as ReactComponent };